<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div class="back_top_name flex-r-sb-c" style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;">
      <van-icon name="arrow-left" @click="backPath" />
      <div class="top_name">代理品牌</div>
      <div class="top_icon" />
    </div>
    <div v-if="list.length>0" class="myAgency_box">
      <div v-for="(item,index) in list" :key="index" class="box_item flex-r-sb-c" @click="jumpToBrand(item)">
        <div class="box_item_left flex-r-s-c">
          <div class="box_item_title">{{ item.brandName }}</div>
          <van-image width="2.24rem" height="1.2rem" :src="item.logoUrl" />
        </div>
        <div class="box_item_right flex-r-c-c">
          去采购 <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div v-else class="myAgency_box_empty flex-c-c-c">
      <van-image width="6.13rem" height="4.27rem" :src="require('../../assets/UI2/agencyList_empty.png')" />
      <div class="myAgency_box_empty_tips">您还没有代理的品牌</div>
      <div class="myAgency_box_empty_btn" @click="jumpAgency"> 去代理 </div>
    </div>
  </div>
</template>

<script>
import './index.scss'

import { apiWholesaleAgentRebuy_brandList } from '@/api/agency'
export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getMyBrandList()
  },
  methods: {
    backPath() { window.history.back() },
    jumpAgency() { this.$router.push('/agency/agency') },
    getMyBrandList() { apiWholesaleAgentRebuy_brandList({ page: 1, limit: 999 }).then(res => { this.list = res.data.list }) },
    jumpToBrand(item) { this.$router.push('/agency/myAgencyProduct?wholesaleAgentBrandId=' + item.wholesaleAgentBrandId + '&brandName=' + item.brandName) }

  }
}
</script>

<style>
body {
  background: #f7f7f7;
}
</style>
